module.exports = __webpack_public_path__ + "img/happiness.1f82cd0f.png";